import produce from "immer";
import Tour from "./tour.js";
import ScreenSize from "./screen-size.js";

function create() {
  const tour = Tour.makeModalTour();

  // Steps
  let steps = [
    Tour.highlightElStep(
      tour,
      "You have enabled tracking of Activities. They will appear in this list.",
      { "show": "[data-tour=activity-feed]" }
    ),

    Tour.highlightElStep(
      tour,
      "This is an example email from that contact.",
      { "show": "[data-tour=activities-group-singleton]" }
    ),

    Tour.highlightElStep(
      tour,
      'You can create a Timesheet entry from this activity.',
      { "show": "[data-tour=activities-group-singleton] [data-tour=charge-once-off-button] .cursor-pointer" }
    ),

    Tour.highlightElStep(
      tour,
      "You can delete an activity here.",
      { "show": "[data-tour=activities-group-singleton] [data-tour=delete-button] .cursor-pointer" }
    ),

    Tour.clickElStep(
      `Let's assume you wanted to charge for this email.
      <br/>
      <br/>
      <strong>Click 'Charge Once' here </strong>to review it in the Timesheet. We'll show you how to delete it later.`,
      "[data-tour=activities-group-singleton] [data-tour=charge-once-off-button] .cursor-pointer",
      "top"
    ),

    Tour.highlightElStep(
      tour,
      "The new fee opens here. Note that the activity details are filled out for you.",
      {"show": "#fee-form"},
      "top"
    ),


    produce(
      Tour.clickElStep(
        "To close this fee, <strong>click this 'x'</strong> now",
        "#fee-form [data-tour=close-fee-cross]"
      ),
      step => {
        step.showOn = () => ScreenSize.isMaxWidth("1199px");
      }
    ),

    // Would like to have the user select a matter here, but getting JS error when trying opening
    Tour.highlightElStep(
      tour,
      "Note the matter must be selected / approved. The fee entry will never post until you take this step.",
      { "show": "[data-tour=matter-component] [data-tour=matter-selector]" }
    ),

    Tour.clickElStep(
      `Let's delete this example.
      <br/>
      <br/>
      First, please <strong>click here</strong> to close this entry.`,
      "#fee-form [data-tour=close-fee-cross]"
    ),

    Tour.clickElStep(
      `Now you can delete this fee.
      <br/>
      <br/>
      Please <strong>click here</strong> to delete this entry.`,
      "[data-tour=fee-item] [data-tour=delete-button]"
    ),

    produce(
      Tour.highlightElStep(
        tour,
        "Deleted activities can be found by selecting 'Show Deleted' here. They will be purged after three months.",
        { "show": "[data-tour=activity-feed] > [data-tour=activity-feed-header] #activity-filter-menu" }
      ),
      step => {
        step.showOn = () => !ScreenSize.isIpadPortrait();
      }
    ),

    {
      text:
        "Ok, now your activities will start showing up in the Activity list.<br/><br/>" +
        "Please take advantage of it, and let Mitimes take the stress out of timekeeping!",
      buttons: [{ text: "Done", action: tour.complete }]
    }

  ];

  tour.addSteps(steps);
  return tour;
}

export default { create };
